/* eslint-disable no-unused-expressions */
// Pixel.js
import React, { useEffect } from 'react';

const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;

const Pixel = () => {
    useEffect(() => {
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n;
            n.push = n; n.loaded = true; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = true;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));

        window.fbq('init', PIXEL_ID);
        window.fbq('track', 'PageView');
    }, []);

    return null;
};

export default Pixel;
